import { Dispatch, SetStateAction } from 'react'
import type { Stripe as StripeJs } from '@stripe/stripe-js'

export interface StripeCard {
  brand: string
  last4: string
  exp_month?: number
  exp_year?: number
}

export interface StripeBankAccount {
  last4: string
  bank_name?: string
  account_type?: string
}

export interface StripePaymentMethod {
  id: string
  card?: StripeCard
  us_bank_account?: StripeBankAccount
  type: 'card' | 'us_bank_account'
  isDefault?: boolean
}

export interface StripeCustomer {
  id: string
  email?: string
  invoice_settings?: {
    default_payment_method?: string
  }
  [key: string]: unknown
}

export interface StripeInvoice {
  amount_due?: number
  currency?: string
  [key: string]: unknown
}

export interface StripeSubscription {
  id: string
  default_payment_method?: string
  upcomingInvoice?: StripeInvoice
  [key: string]: unknown
}

export interface StripeConnectAccount {
  [key: string]: unknown
}

export interface StripeCustomerWithDetails {
  customer: StripeCustomer
  paymentMethods: StripePaymentMethod[]
  subscriptions: StripeSubscription[]
  upcomingInvoice: StripeInvoice | null
}

// Context Props
export interface StripeContextProps {
  stripe: StripeJs | null
  setStripe?: Dispatch<SetStateAction<StripeJs | null>>
}

export const StripeContextDefaultValues: StripeContextProps = {
  stripe: null,
  setStripe: () => {},
}
